<div
  id="scrollResumeStep"
  *ngIf="resumeStep?.isVisible"
  class="container-resumestep md:container flex mx-auto px-5 md:px-3 my-auto pb-1">
  <div class="container flex flex-wrap gap-y-2 items-center" [ngClass]="getAlign()">
    <div *ngFor="let step of resumeStep.steps" class="text-resumestep h-fit">
      <a
        *ngIf="step.isVisible"
        matomoClickAction="Stepper"
        [routerLink]="['/' + step.url]"
        [ngClass]="{ 'text-resumestepCurrent': step.current }">
        {{ step.step }}</a
      >
    </div>
  </div>
</div>
